import { FormattedMessage } from 'react-intl';
import Section from './Section';
import { useRef, useState } from 'react';
import List from '@/components/List/List';
import { fetchPartners } from '@/lib/api';
import SearchTextField from '@/components/SearchTextField/SearchTextField';
import useInfiniteScroll from '@/hooks/useInfiniteScroll';
import { PartnerSchema } from '@/lib/types';

const Brand = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[];
  onChange: (values: string[]) => void;
  mode?: 'light' | 'dark';
}) => {
  const [search, setSearch] = useState('');
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const { data, isLoading, isFetchingNextPage } = useInfiniteScroll({
    fetchFn: fetchPartners,
    queryKey: ['games', { type: ['brand'] }],
    params: { type: ['brand'] },
    scrollContainerRef:
      scrollContainerRef as React.RefObject<HTMLElement>,
    pageSize: 10,
    scrollThreshold: 200,
  });
  const brandItems = (data as PartnerSchema[])?.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.name,
  }));

  const filteredItems =
    brandItems?.filter((item) =>
      item.value
        .toString()
        .toLowerCase()
        .includes(search.toLowerCase()),
    ) || [];

  return (
    <Section
      title={<FormattedMessage id="brand" defaultMessage="Brand" />}
      mode={mode}
      defaultOpen={value.length > 0}
    >
      <SearchTextField
        value={search}
        onChange={(newV) => setSearch(newV)}
        mode={mode}
      />
      <List
        ref={scrollContainerRef}
        loading={isLoading || isFetchingNextPage}
        items={filteredItems}
        values={value}
        onChange={(values) => onChange(values as string[])}
        mode={mode}
      />
    </Section>
  );
};

export default Brand;
